module.exports = __webpack_public_path__ + "static/data-6a86665b0c82d0519c0f4cb83ef085d9.png";